export const logInRoutePath = "/logIn";

export const mainMenuParentRoutePath = "/mainmenu/*";
export const mainMenuRoutePath = "/mainmenu";